(()=>{
  'use strict';

  const JEWELLERY_HANDLES = new Set(['all-jewellery','chains','rings','earrings','bracelets','necklaces','charms-pendants','bangles','cufflinks','wedding-bands','womens-jewellery','mens-jewellery','unisex-jewellery']);
  const CATEGORY_FILTERS = {
    chains: ['availability','price','chain style','chain link type','link type','length','width / gauge','width','gauge','metal colour','metal','metal purity','recipient','gender','department','construction'],
    rings: ['availability','price','ring style','style','ring size','size','recipient','gender','department','metal colour','metal','metal purity','gemstone','main stone','stone','stone shape','shape'],
    earrings: ['availability','price','earring style','style','recipient','gender','department','metal colour','metal','metal purity','gemstone','main stone','stone','stone shape','shape'],
    bracelets: ['availability','price','bracelet style','style','length / size','length','size','width','gauge','metal colour','metal','metal purity','gemstone','main stone','stone','recipient','gender','department'],
    necklaces: ['availability','price','necklace style','style','length','pendant / no pendant','pendant','metal colour','metal','metal purity','gemstone','main stone','stone','recipient','gender','department'],
    'charms-pendants': ['availability','price','pendant style / motif','pendant style','motif','style','metal colour','metal','metal purity','gemstone','main stone','stone','recipient','gender','department','chain included'],
    bangles: ['availability','price','bangle style','style','size','width','metal colour','metal','metal purity','gemstone','main stone','stone','recipient','gender','department'],
    cufflinks: ['availability','price','style','metal colour','metal','metal purity','gemstone','main stone','stone','recipient','gender','department']
  };
  const LABEL_MAP = {
    'chain link type':'Chain Style','link type':'Chain Style','chain style':'Chain Style',
    'width':'Width / Gauge','gauge':'Width / Gauge','width / gauge':'Width / Gauge',
    'gender':'Recipient','department':'Recipient','recipient':'Recipient',
    'metal':'Metal Colour','metal colour':'Metal Colour','metal purity':'Metal Purity',
    'size':'Size','ring size':'Ring Size','main stone':'Gemstone','stone':'Gemstone',
    'shape':'Stone Shape','stone shape':'Stone Shape','style':'Style'
  };
  const ORDER = {
    'availability':10,'price':20,'chain style':30,'ring style':30,'earring style':30,'bracelet style':30,'necklace style':30,'pendant style / motif':30,'style':30,
    'length':40,'ring size':40,'size':40,'length / size':40,'width / gauge':50,'width':50,'gauge':50,
    'metal colour':60,'metal':60,'metal purity':70,'recipient':80,'gender':80,'department':80,'gemstone':90,'main stone':90,'stone shape':100,'shape':100,'construction':110,'chain included':110,'pendant / no pendant':110,'motif':110
  };
  const CHAIN_STYLES = ['Cuban','Curb','Figaro','Franco','Belcher','Rope'];

  const context = document.querySelector('[data-imperial-discovery-context]')?.dataset.imperialDiscoveryContext || '';
  const handle = context.startsWith('collection-') ? context.slice(11) : '';
  if (!JEWELLERY_HANDLES.has(handle)) return;
  document.documentElement.dataset.imperialJewelleryDiscovery = handle;

  const norm = s => (s || '').replace(/\s+/g,' ').trim().toLowerCase();
  const textLabel = details => details?.querySelector('summary span, summary .facets__summary-label, summary')?.textContent?.replace(/\s+/g,' ').trim() || '';
  const filterDetails = root => [...(root || document).querySelectorAll('details.js-filter, .facets__disclosure, .mobile-facets__details')];

  function canonicalLabel(raw){
    const n = norm(raw).replace(/:$/,'');
    if (n === 'style') {
      if (handle === 'rings') return 'Ring Style';
      if (handle === 'earrings') return 'Earring Style';
      if (handle === 'bracelets') return 'Bracelet Style';
      if (handle === 'necklaces') return 'Necklace Style';
      if (handle === 'charms-pendants') return 'Pendant Style / Motif';
    }
    if (n === 'size' && handle === 'rings') return 'Ring Size';
    if (n === 'size' && handle === 'bracelets') return 'Length / Size';
    if (n === 'pendant' && handle === 'necklaces') return 'Pendant / No Pendant';
    if (LABEL_MAP[n]) return LABEL_MAP[n];
    return raw.replace(/\s+/g,' ').trim().replace(/:$/,'');
  }

  function allowedForCategory(raw){
    if (handle === 'all-jewellery' || !CATEGORY_FILTERS[handle]) return true;
    const n = norm(raw).replace(/:$/,'');
    return CATEGORY_FILTERS[handle].some(x => n === x || n.includes(x));
  }

  function rankFor(raw){
    const n = norm(raw).replace(/:$/,'');
    return ORDER[n] ?? 200;
  }

  function normalizeFacetGroup(details){
    if (!details || details.dataset.imperialJewelleryV2 === '1') return;
    const raw = textLabel(details);
    if (!raw) return;
    if ((handle === 'chains') && ['brand','vendor'].includes(norm(raw))) {
      details.hidden = true;
      details.setAttribute('aria-hidden','true');
      details.dataset.imperialJewelleryV2 = '1';
      return;
    }
    if (!allowedForCategory(raw)) {
      details.hidden = true;
      details.setAttribute('aria-hidden','true');
      details.dataset.imperialJewelleryV2 = '1';
      return;
    }
    details.hidden = false;
    details.removeAttribute('aria-hidden');
    details.style.setProperty('--imperial-filter-order', String(rankFor(raw)));
    details.style.order = String(rankFor(raw));
    const pretty = canonicalLabel(raw);
    details.querySelectorAll('summary span, summary .facets__summary-label').forEach(el => {
      if (norm(el.textContent) === norm(raw)) el.textContent = pretty;
    });
    hideZeroValueRows(details);
    details.dataset.imperialJewelleryV2 = '1';
  }

  function hideZeroValueRows(details){
    details.querySelectorAll('li, .list-menu__item, .facets__item').forEach(row => {
      const input = row.querySelector('input[type="checkbox"], input[type="radio"]');
      if (!input || input.checked) return;
      const rowText = row.textContent || '';
      const zero = /\(\s*0\s*\)\s*$/.test(rowText.trim()) || input.disabled;
      if (zero) row.hidden = true;
    });
  }

  function styleFacet(){
    return filterDetails().find(d => {
      const n = norm(textLabel(d));
      return ['chain style','chain link type','link type'].includes(n);
    });
  }

  function styleInput(details, style){
    if (!details) return null;
    return [...details.querySelectorAll('input[type="checkbox"], input[type="radio"]')].find(input => {
      const id = input.id;
      const label = id ? document.querySelector(`label[for="${CSS.escape(id)}"]`) : input.closest('label');
      const candidate = norm(label?.textContent || input.value || '');
      return candidate === norm(style) || candidate.startsWith(norm(style) + ' ');
    }) || null;
  }

  function buildChainStyleStrip(){
    if (handle !== 'chains') return;
    const hub = document.querySelector('.imperial-discovery-refine, .imperial-discovery-hub, [data-imperial-jewellery-discovery], .collection-hero, .collection') || document.querySelector('main');
    if (!hub || document.querySelector('[data-imperial-chain-style-strip]')) return;
    const details = styleFacet();
    if (!details) return;
    const available = CHAIN_STYLES.map(style => [style, styleInput(details, style)]).filter(([,input]) => input && !input.disabled);
    if (!available.length) return;
    const section = document.createElement('section');
    section.className = 'imperial-chain-style-strip';
    section.dataset.imperialChainStyleStrip = '1';
    section.setAttribute('aria-label','Shop Chains by Style');
    section.innerHTML = '<div class="imperial-chain-style-strip__inner"><h2>Shop Chains by Style</h2><div class="imperial-chain-style-strip__chips"></div></div>';
    const chips = section.querySelector('.imperial-chain-style-strip__chips');
    available.forEach(([style,input]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'imperial-chain-style-chip';
      button.dataset.chainStyle = style;
      button.textContent = style;
      button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      button.addEventListener('click', () => {
        const current = styleInput(styleFacet(), style);
        if (current && !current.disabled) current.click();
      });
      chips.append(button);
    });
    const discovery = document.querySelector('.imperial-discovery-refine, .imperial-discovery-hub, [data-imperial-jewellery-discovery]');
    if (discovery?.parentNode) discovery.insertAdjacentElement('afterend', section);
    else hub.prepend(section);
  }

  function chainMetaFromTitle(title){
    const raw = (title || '').replace(/\s+/g,' ').trim();
    if (!raw) return '';
    const style = (raw.match(/\b(Cuban|Curb|Figaro|Franco|Belcher|Rope|Spiga|Singapore|Trace|Box|Snake|Wheat|Paper\s*Clip)\b/i) || [])[1];
    const widthMatch = raw.match(/\b(\d+(?:\.\d+)?)\s*mm\b/i);
    const lengthMatch = raw.match(/\b(1[4-9]|2\d|30)\s*(?:"|inch(?:es)?)\b/i);
    const purity = (raw.match(/\b(9ct|10ct|14ct|18ct|22ct|925|950)\b/i) || [])[1];
    const metal = (raw.match(/\b(Yellow Gold|White Gold|Rose Gold|Sterling Silver|Platinum|Palladium|Silver)\b/i) || [])[1];
    const parts = [];
    if (style) parts.push(style.replace(/\s+/g,' '));
    if (widthMatch) parts.push(`${widthMatch[1]} mm`);
    if (lengthMatch) parts.push(`${lengthMatch[1]}"`);
    if (purity || metal) {
      let material = [purity, metal].filter(Boolean).join(' ');
      material = material.replace(/925\s+Sterling Silver/i,'925 Sterling Silver').replace(/925\s+Silver/i,'925 Silver');
      if (material) parts.push(material);
    }
    return [...new Set(parts)].join(' · ');
  }

  function genericMetaFromTitle(title){
    const raw = (title || '').replace(/\s+/g,' ').trim();
    const purity = (raw.match(/\b(9ct|10ct|14ct|18ct|22ct|925|950)\b/i) || [])[1];
    const metal = (raw.match(/\b(Yellow Gold|White Gold|Rose Gold|Sterling Silver|Platinum|Palladium|Silver)\b/i) || [])[1];
    const stylePatterns = {
      rings: /\b(Signet|Solitaire|Halo|Cluster|Eternity|Wedding|Dress|Trilogy|Three Stone)\b/i,
      earrings: /\b(Stud|Hoop|Huggie|Drop|Dangle|Cluster)\b/i,
      bracelets: /\b(Tennis|Curb|Cuban|Figaro|Rope|Belcher|Bangle|Cuff|Chain)\b/i,
      necklaces: /\b(Chain|Pendant|Station|Lariat|Choker)\b/i,
      'charms-pendants': /\b(Cross|Heart|Initial|Crucifix|Saint|Star|Zodiac|Charm|Pendant)\b/i
    };
    const style = stylePatterns[handle] ? (raw.match(stylePatterns[handle]) || [])[1] : '';
    const parts = [];
    if (style) parts.push(style);
    if (purity || metal) parts.push([purity,metal].filter(Boolean).join(' '));
    return [...new Set(parts)].join(' · ');
  }

  function enhanceCards(){
    if (!['chains','rings','earrings','bracelets','necklaces','charms-pendants'].includes(handle)) return;
    document.querySelectorAll('[data-imperial-list-item], .grid__item .card-wrapper, .product-grid .grid__item').forEach(card => {
      if (card.querySelector('.imperial-jewellery-card-meta-v2')) return;
      const heading = card.querySelector('.card__heading, .card-information__text, h3, h2');
      if (!heading) return;
      const title = card.dataset.imperialProductName || heading.textContent?.trim() || '';
      const meta = handle === 'chains' ? chainMetaFromTitle(title) : genericMetaFromTitle(title);
      if (!meta) return;
      const el = document.createElement('p');
      el.className = 'imperial-jewellery-card-meta-v2';
      el.textContent = meta;
      heading.insertAdjacentElement('afterend', el);
    });
  }

  function improveMobileAction(){
    document.querySelectorAll('.mobile-facets__footer .button, .mobile-facets__footer button').forEach(btn => {
      const t = norm(btn.textContent);
      if (t === 'apply' || t.startsWith('apply ')) btn.textContent = 'Show Products';
    });
  }

  function refreshChainStyleStrip(){
    if (handle !== 'chains') return;
    const details = styleFacet();
    const strip = document.querySelector('[data-imperial-chain-style-strip]');
    if (!details) {
      strip?.remove();
      return;
    }
    if (!strip) {
      buildChainStyleStrip();
      return;
    }
    strip.querySelectorAll('[data-chain-style]').forEach(button => {
      const input = styleInput(details, button.dataset.chainStyle || '');
      if (!input || input.disabled) {
        button.hidden = true;
        return;
      }
      button.hidden = false;
      button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
    });
  }

  function removeLegacyLengthRoutes(){
    if (!['chains','necklaces'].includes(handle)) return;
    document.querySelectorAll('.imperial-discovery-refine--secondary').forEach(el => el.remove());
  }

  function apply(){
    removeLegacyLengthRoutes();
    filterDetails().forEach(normalizeFacetGroup);
    enhanceCards();
    improveMobileAction();
    refreshChainStyleStrip();
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };

  document.addEventListener('DOMContentLoaded', schedule, {once:true});
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('popstate', () => setTimeout(schedule, 50));
  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes?.length || m.removedNodes?.length)) schedule();
  });
  observer.observe(document.documentElement, {childList:true, subtree:true});
  schedule();
})();